import HomeDashboardChartLoadingThumb from './HomeDashboardChartLoadingThumb';

/**
 * 首页经营图加载占位：银灰色柱+折线缩略图（首页专用，不依赖图表库）。
 */
const HomeDashboardChartLoading = ({ label = '加载图表' }) => (
	<div className='dashboard-home-chart-loading' role='status' aria-live='polite' aria-label={label}>
		<div className='dashboard-home-chart-loading__plot-wrap' aria-hidden='true'>
			<div className='dashboard-home-chart-loading__thumb'>
				<HomeDashboardChartLoadingThumb />
			</div>
		</div>
		<span className='visually-hidden'>加载中</span>
	</div>
);

export default HomeDashboardChartLoading;
